const initialState = {};

export function adminReducers(state = initialState, action) {
  switch (action?.type) {
    case 'ADMIN_ALL_ORDERS':
      return {
        ...state,
        orders: [...action?.payload],
      };
    case 'SINGLE_ORDER_DETAILS':
      return {
        ...state,
        order: action?.payload,
      };

    default:
      return state;
  }
}
